import React from "react";

const CredentialsTour = () => {
  return (
    <div>
      <p>
       See all important application details here.
      </p>
    </div>
  );
};

export default CredentialsTour;

export const CredentialsAppName = () => {
  return (
    <div>
      {" "}
      <p>Copy the app name and past it in the client config</p>
    </div>
  );
};

export const CredentialsAuthKey = () => {
  return (
    <div>
      {" "}
      <p>Copy the auth key and past it in the  client config</p>
    </div>
  );
};

export const CredentialsRestKey = () => {
  return (
    <div>
      <p>Copy the rest api key and past it in the client config</p>
    </div>
  );
};
